export default "__VITE_ASSET__DciWV4ho__"